import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* get_AccountPropertiesList(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account-properties?page=" + actions.page
        : apiUrl + "/opa-account-properties" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_ACCOUNT_PROPERTIES_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({ type: "LIST_ACCOUNT_PROPERTIES_RESPONSE_GET", value: error });
  }
}

function* get_AccountProperties(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-account-property/"
        : `${apiUrl}/opa-account-property/${actions.query}?include=googlePlace,images,claimedAccount`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response) {
        responseStatus = "success";
      } else {
        responseStatus = response;
      }
    }

    yield put({ type: "ACCOUNT_PROPERTIES_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "ACCOUNT_PROPERTIES_RESPONSE_GET", value: error });
  }
}

function* add_AccountProperties(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-account-property";

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* edit_AccountProperties(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-account-property/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* edit_AccountPropertiesList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-account-property/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* delete_AccountProperties(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-account-property/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "ACCOUNT_PROPERTIES_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

export function* getSagaAccountPropertiesList() {
  yield takeEvery("GET_ACCOUNT_PROPERTIES_LIST", get_AccountPropertiesList);
}

export function* getAccountProperties() {
  yield takeEvery("GET_ACCOUNT_PROPERTIES", get_AccountProperties);
}

export function* addAccountProperties() {
  yield takeEvery("ADD_ACCOUNT_PROPERTIES", add_AccountProperties);
}

export function* editAccountProperties() {
  yield takeEvery("EDIT_ACCOUNT_PROPERTIES", edit_AccountProperties);
}

export function* editAccountPropertiesList() {
  yield takeEvery("EDIT_ACCOUNT_PROPERTIES_LIST", edit_AccountPropertiesList);
}

export function* deleteAccountPropertiesSaga() {
  yield takeEvery("DELETE_ACCOUNT_PROPERTIES", delete_AccountProperties);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
